import { render } from "./boardView.vue?vue&type=template&id=0f48e94a&scoped=true"
import script from "./boardView.vue?vue&type=script&lang=js"
export * from "./boardView.vue?vue&type=script&lang=js"

import "./boardView.vue?vue&type=style&index=0&id=0f48e94a&scoped=true&lang=css"
import "./boardView.vue?vue&type=style&index=1&id=0f48e94a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f48e94a"]])

export default __exports__